var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-menu', {
    attrs: {
      "bottom": "",
      "rounded": "0"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "rounded-0 justify-start pa-0",
          attrs: {
            "text": "",
            "color": "grey darken-1",
            "width": "100%"
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" 더보기 "), _vm.selected.length ? _c('v-badge', {
          staticClass: "ml-2",
          attrs: {
            "content": _vm.selected.length,
            "inline": "",
            "color": "primary"
          }
        }) : _vm._e()], 1)];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 rounded-0"
  }, [_c('v-chip-group', {
    attrs: {
      "multiple": "",
      "color": "primary",
      "column": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, _vm._l(_vm.children, function (child) {
    return _c('v-chip', {
      key: child.name,
      attrs: {
        "value": child,
        "filter": "",
        "outlined": ""
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return function () {}($event);
        }
      }
    }, [_vm._v(" " + _vm._s(child.name) + " ")]);
  }), 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }